import { defineComponent, inject, ref, onMounted, onUnmounted } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "SwiperItem",
  setup(__props) {
    const swiperData = inject("swiper");
    const swiperItemStyle = ref();
    swiperData.addSwiperItem();
    onMounted(() => {
      swiperItemStyle.value = {
        width: `${swiperData.swiperRef.value.offsetWidth}px`,
        height: `${swiperData.swiperRef.value.offsetHeight}px`
      };
    });
    onUnmounted(() => {
      swiperData.removeSwiperItem();
    });
    return { __sfc: true, swiperData, swiperItemStyle };
  }
});
export {
  _sfc_main as default
};
